/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Pairing_Style_PodInputs */



/**
* | output |
* | --- |
* | "Pod rounds" |
*
* @param {Tournaments_Lib_Pairing_Style_PodInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_pairing_style_pod = /** @type {((inputs?: Tournaments_Lib_Pairing_Style_PodInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Pairing_Style_PodInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pod-Runden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes en pods")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("分组轮")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("多人桌輪")
	if (locale === "ko") return /** @type {LocalizedString} */ ("팟 라운드")
	return /** @type {LocalizedString} */ ("Pod rounds")
});